export default "__VITE_ASSET__kcceIRK5__"